import BaseApi from './BaseApi';

export type StaffId = {
  bucketName: string;
};

/**
 * 会社アイコン削除API。
 */
class DeleteCompanyImgApi extends BaseApi {
  async delete(params: StaffId) {
    return await this.execute('deleteCompanyImgApi', {
      method: 'DELETE',
      body: params
    }).then(({ status }) => status === 1);
  }
}

export default DeleteCompanyImgApi;
